module.exports = __webpack_public_path__ + "img/BERTHIAUME-DU TREMBLAY.a6b51da5.jpg";